import { atualUfDefinition } from "@/helpers/utils";
export const routes = [
  {
    path: "/dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "./components/Index"),
    name: "dashboard",
  },
  {
    path: "/indicadores/game",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "./components/IndicadoresGame"
      ),
    name: "indicadores.game",
    meta: {
      requiresAuth: atualUfDefinition.isSala ? true : false,
    },
  },
  {
    path: "/indicadores/visao-uf",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "./components/VisaoUf"
      ),
    name: "indicadores.visao-uf",
    meta: {
      requiresAuth: atualUfDefinition.isSala ? true : false,
    },
  },
  {
    path: "/indicadores/municipio/:uf/:municipioId/analise",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "./components/RaioXMunicipio"
      ),
    name: "indicadores.municipio.analise",
    meta: {
      requiresAuth: atualUfDefinition.isSala ? true : false,
    },
  },
  {
    path: "/indicadores/uf/:uf/analise",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "./components/InfograficoIanUf"
      ),
    name: "indicadores.uf.analise",
    meta: {
      requiresAuth: atualUfDefinition.isSala ? true : false,
    },
  },
  {
    path: "/indicadores/nacional/analise",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "./components/InfograficoIanUf"
      ),
    name: "indicadores.nacional.analise",
    meta: {
      requiresAuth: atualUfDefinition.isSala ? true : false,
    },
  },
  {
    path: "/indicadores/nacional/comparativo-ian",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "./components/ComparativoIanNacional"
      ),
    name: "indicadores.nacional.comparativo-ian",
    meta: {
      requiresAuth: atualUfDefinition.isSala ? true : false,
    },
  },
  {
    path: "/indicadores/primarios",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "./components/IndicadoresManuais"
      ),
    name: "indicadores.primarios",
  },
  {
    path: "/indicadores/execucao",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "./components/IndicadoresExecucao"
      ),
    name: "indicadores.execucao",
  },
];
